import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CountryService {

  constructor(public http:HttpClient) { }

  // getAll(){
  //   return this.http.post(environment.api_link+"/api/source_country",{})
  // }
  getAll(){
    return this.http.get(environment.api_link+"/api/auth/reg-country-list",{})
  }

  getCountryList(){
    return this.http.get(environment.api_link+"/api/auth/get-country")
  }
}
